<mat-toolbar mat-dialog-title class="ori-elevation-z4 header">
  <h3>
    {{ (isLoggedIn ? "logout.title" : "login.title") | translate }}
  </h3>
  <mat-icon class="icon icon-close" (click)="close()" color="primary" svgIcon="close"></mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <iframe height="440" id="auth_iframe" [src]="login_url" title="{{ 'login.title' | translate }}"></iframe>
</mat-dialog-content>
